import $ from 'jquery';

// import script accordingly
// import "./themes/header/_header";
import './themes/homepage-swiper';
